import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { filter, map, Observable } from 'rxjs';

@Component({
  selector: 'app-non-web-access-user',
  templateUrl: './non-web-access-user.component.html',
  styleUrls: ['./non-web-access-user.component.scss']
})
export class NonWebAccessUserComponent implements OnInit {

  ResetMessage:string = "Your password has been updated. Please log into the CellGate mobile app with your updated password.";
  NewsetMessage:string = "Your password has been created. Please log into the CellGate mobile app with your newly created password.";
  DisplayMessage:string = this.ResetMessage;
  Title:string = "Password Updated";
  state$: Observable<object>;
  constructor(private activatedRoute: ActivatedRoute,private route: ActivatedRoute,private router: Router) 
  {   }

  ngOnInit(): void {
   var data=  sessionStorage.getItem('isnonwebaccessuserset');
   
      if(data !=undefined && data!=null && data == 'set' ){
        this.DisplayMessage = this.NewsetMessage;
        
        this.Title = this.Title.replace('Updated', 'Created');
      }
  }
  ngOnDestroy() {
    sessionStorage.removeItem('isnonwebaccessuserset');   
  }
}
